import React from 'react'
import { personalizedServingText } from '../helpers/personalizedServingText'

export const ServingCitiesText = ({ blog, path }) => <p className={`${blog ? 'block text-center mb-6' : 'text-left'} text-base font-semibold`}>{personalizedServingText(path)}</p>

